//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('workGrpMenu', {
//        templateUrl: 'views/components/views/workGrpMenu/workGrpMenu.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'workGrpMenuService', function ($stateParams, workGrpMenuService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let workGrpKeyno = $stateParams.workgrp_keyno;

//            vm.model = {
//                menu: {}
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadMenu() {
//                vm.model.menu = (await workGrpMenuService.getMenu({ workgrp_keyno: workGrpKeyno }))[0];
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadMenu();
//            };

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
